import React from 'react';

export default (props) => {

    return (
        <ul className='submenu homepage-menu'>
            {props.flattenedMenu.map((m, i) => <li className={(m.path === props.selectedHomepage) || (!props.selectedHomepage && i === 0) ? 'selected' : ''} onClick={() => props.onItemClick(m.path)} key={m.label}>{m.label}</li>)}
        </ul>
    );
}